import { createFileRoute } from '@tanstack/react-router';

import { NIS2ISMSPage } from '@/features/nis2/components/NIS2ISMSPage';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/nis2/isms')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.nis2Isms', { defaultValue: 'NIS2 ISMS' }),
  }),
  component: NIS2ISMSPage,
});
